(function(angular) {
    angular.module('bizPartEngage').directive('bizProfileMenu', bizProfileMenuDirective);

    bizProfileMenuDirective.$inject = ["bizCore"];

    function bizProfileMenuDirective(bizCoreProvider) {
        var directive = {
            restrict: "E",
            scope: true,
            templateUrl: bizCoreProvider.getView('core.directives.profilemenu', "FrontEnd/Core/Directives/Views/ProfileMenu.html"),
            controller: bizCoreProvider.getController('core.directives.profilemenu', bizProfileMenuController),
            controllerAs: "vm"
        };

        bizProfileMenuController.$inject = ["$rootScope"];

        function bizProfileMenuController($rootScope) {
        	var vm = this;
			vm.IsActive = IsActive;

			function IsActive(m) {
				if(m.State === $rootScope.CurrentState.name || m.State === $rootScope.CurrentState.data?.parentState)
					return true;

				return false;
			}

        	$rootScope.Initialized.then(function () {
        		vm.States = [{
        			Phrase: "CORE.MYPAGE",
        			State: "base.core.profile.home",
        			Icon: "fa fa-user"
        		}, {
        			Phrase: "CORE.LEADERBOARDS",
        			State: "base.core.profile.leaderboards",
        			Icon: "fa fa-bar-chart",
        			Enabled: $rootScope.HasModuleAccess('LEVEL_SYSTEM', $rootScope.AccessTypeRight.Read),
        			PortalSettingForEnable: "IsLevelSystemEnabled"
        		}, {
        			Phrase: "CORE.MYCOLLEAGUES",
        			State: "base.core.profile.colleagues",
        			Icon: "fa fa-users",
        			Enabled: $rootScope.HasModuleAccess('UNITS', $rootScope.AccessTypeRight.Read),
        			PortalSettingForEnable: "IsUnitEnabled"
        		}, {
                    Phrase: "CORE.WELCOMEPAGE",
        			State: "base.core.welcome",
        			Icon: "fas fa-door-open"
                }, {
                    Phrase: "CORE.MYSETTINGS",
                    State: "base.core.profile.settings",
                    Icon: "fa fa-cog"
                }];
        	})
        }

        return directive;
    }
})(window.angular);
